import { useTranslation } from 'react-i18next';
import { Button, useScreenSize } from '@robocorp/components';
import { IconCode } from '@robocorp/icons/iconic';
import { FC } from 'react';
import { CurrentWorkspaceRestriction } from '~/components';

interface Props {
  onOpen: () => void;
}

export const WorkspaceInfo: FC<Props> = ({ onOpen }) => {
  const { t } = useTranslation();
  const showButtonLabel = !useScreenSize('m');

  return (
    <>
      <CurrentWorkspaceRestriction permission="read_workspace_keys">
        <Button variant="ghost" onClick={onOpen} icon={IconCode}>
          {showButtonLabel ? t('APIHelper.title') : undefined}
        </Button>
      </CurrentWorkspaceRestriction>
    </>
  );
};
